<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          証明書発行申請の入力フォーム一覧
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
            </template>
            <div v-if="this.$root.adminFlg == false">入力フォーム(登録したもの・共同編集者となっているもの)について</div>
            <div v-if="this.$root.adminFlg == true">入力フォーム(全ユーザーの登録したもの)について</div>
            <div>公開状態の変更・編集・削除ができます。</div>
          </v-tooltip>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 検索用のテキスト入力 -->
        <v-autocomplete
          v-model="postUsersFilterValue"
          label="作成者指定"
          placeholder="作成者指定"
          :items="postUsers"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="9" md="9" lg="9" xl="9" class="d-flex text-right">
        <v-btn color="accent" class="ml-auto mt-0 black--text" @click="toCertificateRequestTemplateEdit">フォーム作成</v-btn>
      </v-col>

    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="certificates"
          :items-per-page="-1"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          :loading="isCertificateRequestTemplatesLoading" loading-text="読込中"
        >
          <!-- ラベル：更新日・作成者・共同編集 -->
          <template #[`header.postUser`]="{}"> 
            <v-row no-gutters><v-col cols="12" justify="center">更新日時</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">作成者</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">共同編集</v-col></v-row>
          </template>
          <!-- 更新日・作成者・共同編集 -->
          <template #[`item.postUser`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.updDate }}</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.postUser }}</v-col></v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                <span v-if="item.editAllowIds.length > 1 && item.editAllowFlg == false">設定有</span>
                <span v-if="item.editAllowIds.length > 1 && item.editAllowFlg == true">権限有</span>
              </v-col>
            </v-row>
          </template>
          <!-- ラベル：タイトル -->
          <template #[`header.title`]="{}"> 
            <v-row no-gutters><v-col cols="12" justify="center">名称</v-col></v-row>
          </template>
          <!-- タイトル -->
          <template #[`item.title`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.title }}</v-col></v-row>
          </template>
          <!-- 並び順 -->
          <template #[`item.orderNo`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.orderNo }}</v-col></v-row>
          </template>
          <!-- 編集 -->
          <template #[`item.edit`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-tooltip top v-if="item.editAllowFlg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small outlined color="green" v-bind="attrs" v-on="on" @click="onClickEditItem(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>入力フォームを編集する</span>
                </v-tooltip>
                <v-tooltip top v-if="!item.editAllowFlg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small outlined v-bind="attrs" v-on="on" :disable="true">
                      <v-icon color="grey">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>作成者か共同編集者のみ編集可能です</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
          <!-- 公開期間 -->
          <template #[`item.publishDate`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center" style="white-space : nowrap;">{{ item.openDate }}～</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center" style="white-space : nowrap;">{{ item.closeDate }}</v-col></v-row>
          </template>
          <!-- 公開状態 -->
          <template #[`item.isOpen`]="{ item }">
            <v-btn color="accent" class="black--text" v-if="item.publishFlg && !item.beforeOpeningFlg" @click="onClickChangeOpenStatus(item)">公開中</v-btn>
            <v-btn color="white" class="black--text" v-if="item.publishFlg && item.beforeOpeningFlg" @click="onClickChangeOpenStatus(item)">公開前</v-btn>
            <v-btn color="grey" class="black--text" v-if="!item.publishFlg" @click="onClickChangeOpenStatus(item)">停止中</v-btn>
          </template>
          <!-- 操作 -->
          <template #[`item.action`]="{ item }">
            <v-row no-gutters>
              <v-col cols="6" justify="center">
                <v-tooltip bottom v-if="item.deleteAllowFlg == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="onClickDeleteItem(item)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>入力フォームを削除する</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" :disable="true">
                      <v-icon color="grey">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>作成者のみ削除可能です</span>
                </v-tooltip>
              </v-col>
              <v-col cols="6" justify="center">
                <v-tooltip left v-if="item.deleteAllowFlg == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="onClickEditAllowDialog(item)">
                      <v-icon color="green">mdi-account-multiple-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>共同編集者を変更する</span>
                </v-tooltip>
                <v-tooltip left v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" :disable="true">
                      <v-icon color="grey">mdi-account-multiple-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>共同編集者は作成者のみ変更可能です</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

    <!-- 共同編集者変更モーダル -->
    <v-dialog
      v-model="editAllowDialog"
      max-width="700"
      min-height="120"
      persistent
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="editAllowDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              共同編集者を変更する
            </v-col>
            <v-col cols="2" justify="center">
              <v-btn color="accent" class="black--text" @click="changeEditAllowIds()" width="90%">
                変更
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text class="d-flex justify-center flex-column">
          <v-row dense>
            <v-col dense cols="12" justify="center">
              <v-autocomplete
                v-model="editAllowIds"
                label="共同編集者"
                placeholder="共同編集者"
                :items="teacherList"
                outlined
                dense
                multiple
                deletable-chips
                clearable
                small-chips
                hide-details="auto"
                background-color="white"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>
  
<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import Enumerable from "linq";
export default {
  data() {
    return {
      postUsersFilterValue: "",
      postUsers : [],
      headers: [
        { text: "更新日時/作成者/共同編集", value: "postUser", width: "15%", filter: this.postUserFilter },
        { text: "タイトル", value: "title", width: "40%" },
        { text: "並び順", value: "orderNo", width: "5%" },
        { text: "編集", value: "edit", width: "5%" },
        { text: "公開開始/終了", value: "publishDate", width: "15%" },
        { text: "公開状態", value: "isOpen", width: "10%", filter: this.publishFilter },
        { text: "操作", value: "action", width: "10%" },
      ],
      certificates: [],
      isCertificateRequestTemplatesLoading: false,

      // 共同編集者変更用ダイアログ
      editAllowDialog: false,
      editAllowCertificateId: "",
      editAllowIds: [],
      teacherList:[],
      baseTeacherList:[],
    };
  },
  // 初期表示時データ読み込み
  async created() {
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
    
    // 教員リストの取得
    await schoolAidHomeLogined({funcName: "commonGetTeachers", includeFlg: true}).then((ret) => {
      this.baseTeacherList = ret.data.teacherList;
    })
    await this.reload();
  },
  methods: {
    // 作成者名フィルタ
    postUserFilter(value) {
      if (!this.postUsersFilterValue) {
        return true;
      }
      return value.toString().includes(this.postUsersFilterValue);
    },
    async reload() {
      let temp_postUsers = new Set();
      this.certificates = [];
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isCertificateRequestTemplatesLoading = true;
      const param = {
        funcName:"loadCertificateRequestTemplateList",
      }
      await schoolAidHomeLogined(param).then((certificates) => {
        let ret = [];
        certificates.data.forEach((certificate) => {
          temp_postUsers.add(certificate.postUser);
          const row = {
            insDate: certificate.insDate,
            postUser: certificate.postUser,
            updDate: certificate.updDate,
            title : certificate.title,
            orderNo : certificate.orderNo,
            openDate: certificate.openDate,
            closeDate: certificate.closeDate,
            publishFlg : certificate.publishFlg,
            certificateId : certificate.certificateId,
            beforeOpeningFlg: certificate.beforeOpeningFlg,
            createId: certificate.createId,
            editAllowFlg: certificate.editAllowFlg,
            editAllowIds: certificate.editAllowIds,
            deleteAllowFlg: certificate.deleteAllowFlg,
          };

          ret.push(row);
        });
        this.certificates = ret;
        this.isCertificateRequestTemplatesLoading = false;
        this.postUsers = Array.from(temp_postUsers);
      });
    },

    // 証明書発行申請フォーム登録画面
    toCertificateRequestTemplateEdit() {
      this.$router.push({
        name: "CertificateRequestTemplateEdit",
        params: {
          id: "",
        }
      });
    },

    // 公開状態変更
    async onClickChangeOpenStatus(item) {
      const result = confirm("公開状態を変更してよろしいですか？");
      if (!result) {
        return;
      }
      console.log("item", item);
      // ローディング開始
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const param = {
        funcName: "changeOpenStatusCertificate",
        certificateId: item.certificateId,
        publishFlg: item.publishFlg,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param);
      // ローディング終了
      this.$root.loading = false;
      await this.reload();
    },

    // 証明書発行申請の入力フォーム修正
    onClickEditItem(item) {
      this.$router.push({
        name: "CertificateRequestTemplateEdit",
        params: {
          id: item.certificateId,
        }
      });
    },
    // 論理削除
    async onClickDeleteItem(item) {
      const result = confirm("削除してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const param = {
        funcName: "deleteCertificateRequestTemplate",
        certificateId: item.certificateId,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param);
      // ローディング終了
      this.$root.loading = false;
      await this.reload();
    },
    // 共同編集変更ダイアログを開く
    onClickEditAllowDialog(item){
      this.editAllowCertificateId = item.certificateId;
      let editAllowIdsSet = new Set(item.editAllowIds);
      editAllowIdsSet.delete(item.createId);
      
      this.editAllowCertificateId = item.certificateId;
      this.editAllowIds = Array.from(editAllowIdsSet);
      this.teacherList = Enumerable.from(this.baseTeacherList).where(i => i.value != item.createId).toArray();
      this.editAllowDialog = true;
    },
    // 共同編集ID変更処理
    async changeEditAllowIds(){
      const result = confirm("共同編集者を変更しますか？");
      if (!result) {
        return;
      }

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const param = {
        funcName: "changeEditAllowIdsCertificate",
        certificateId: this.editAllowCertificateId,
        editAllowIds: this.editAllowIds,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data){
          for(let row1 of this.certificates){
            if(row1.certificateId == this.editAllowCertificateId){
              row1.editAllowIds = ret.data;
            }
          }
        } else {
          for(let row2 of this.certificates){
            if(row2.certificateId == this.editAllowCertificateId){
              row2.editAllowIds = [];
            }
          }
        }
        alert("変更しました。");
        this.editAllowDialog = false;
      });
    },
  },
};
</script>

<style scoped>
.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal-header {
  border-bottom: 1px solid #ddd;
}

</style>